module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou8-63bb9c01b7c42600a34752278644bb38.jpg";